import type { StrictOption } from '../../../../components/Toolkit/Inputs/Select';
const selectOptions: StrictOption[] = [
  {
    label: 'I do not have a renewal',
    value: '0',
  },
  {
    label: 'January',
    value: '1',
  },
  {
    label: 'February',
    value: '2',
  },
  {
    label: 'March',
    value: '3',
  },
  {
    label: 'April',
    value: '4',
  },
  {
    label: 'May',
    value: '5',
  },
  {
    label: 'June',
    value: '6',
  },
  {
    label: 'July',
    value: '7',
  },
  {
    label: 'August',
    value: '8',
  },
  {
    label: 'September',
    value: '9',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
];

export interface UseAllianzInsuranceRenewalProps {
  onSelectInsuranceRenewalMonth: (selected?: StrictOption) => void;
  currentInsuranceRenewalMonth?: string | null;
}

const useAllianzInsuranceRenewal = (props: UseAllianzInsuranceRenewalProps) => {
  const { onSelectInsuranceRenewalMonth, currentInsuranceRenewalMonth } = props;

  const findOptionByLabel = (label?: string | null) => {
    return selectOptions.filter((option) => option.label === label)[0];
  };

  const findOptionByValue = (val?: string) => {
    return selectOptions.filter((option) => option.value === val)[0];
  };

  const handleSelectChange = (val: string) => {
    onSelectInsuranceRenewalMonth(findOptionByValue(val));
  };

  const currentInsuranceRenewalMonthOption =
    findOptionByLabel(currentInsuranceRenewalMonth) ?? selectOptions[0];

  return {
    selectOptions,
    handleSelectChange,
    currentInsuranceRenewalMonthOption,
  };
};

export { useAllianzInsuranceRenewal };
